import { storageKeys } from '@/app/constants/storageKeys';
import { storage } from '@/app/storage';

export function logoutPanel() {
  storage.remove(storageKeys.PANEL_CODE);

  const queryParams = new URLSearchParams();

  const deviceCode = storage.get(storageKeys.DEVICE_CODE);
  const groupName = storage.get(storageKeys.GROUP_NAME);

  if (typeof deviceCode === 'string' && deviceCode.trim()) {
    queryParams.append('mac', deviceCode);
  }

  if (typeof groupName === 'string' && groupName.trim()) {
    queryParams.append('grupo', groupName);
  }

  const baseUrl = '/ativar-painel-operacao';
  const queryString = queryParams.toString();
  const targetUrl = queryString ? `${baseUrl}/?${queryString}` : baseUrl;

  window.location.href = targetUrl;
}
